import React, { FunctionComponent } from "react";
import styles from "./Paragraph.module.scss";
import ParagraphProps from "./ParagraphProps.interface";

import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import combineClasses from "helpers/combine-classes";

const Paragraph: FunctionComponent<ParagraphProps> = (props) => {
    const processedBodyText = getProcessedRichtext(props.innerHTML);

    return (
        <div className={combineClasses([styles.wrapper, props.className])} dangerouslySetInnerHTML={processedBodyText}>
            {props.children}
        </div>
    );
};

export default Paragraph;